export default __webpack_public_path__ + "static/island-life-desktop-b660fa5d9151114089c5c93929032d81.webp";